import {ri} from './runner-idle';

export const click_target = document.getElementById('perception-click-target');

let lastMoved = Date.now();
const startDate = Date.now();

click_target?.addEventListener('click', () => {
  ri.stats.perception.value = ri.stats.perception.value.plus(0.05);
  // ri.stats.requestUpdate();
  randomizeLocation();
  ri.focus();
});

function randomizeLocation() {
  lastMoved = Date.now();
  if (click_target) {
    click_target.style.top = `${
      Math.random() * Math.max(270, window.innerHeight)
    }px`;
    click_target.style.left = `${
      Math.random() * Math.max(480, window.innerWidth)
    }px`;
  }
}

setInterval(() => {
  // Make it easier if it's been over 15 minutes and the player hasn't clicked
  if (
    Date.now() - startDate > 1000 * 60 * 15 &&
    ri.stats.perception.value.eq(1)
  ) {
    click_target?.classList.add('big');
  } else {
    click_target?.classList.remove('big');
  }
  if (Date.now() - lastMoved < 10 * 1000) return;
  if (Math.random() < 0.1) {
    randomizeLocation();
  }
}, 1000);
